// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"195af61d","453":"68693753","732":"de3c9055"}[chunkId] + ".chunk.js";
};